import { RmRackDetails } from "@gtpl/shared-models/masters";
import { RmZones } from "../../rm-zones/rm-zones.entity";
import { ZoneMaster } from "../../zone-master/zone-master.entity";
import { RmRack } from "../rm-racks.entity";
import { RmRackDTO } from "./rm-racks.dto";

export class RmRackAdapter {
    convertDtoToEntity(dtoObj: RmRackDTO,  isUpdate: boolean = false ): RmRack {
        try {
            const entityObj = new RmRack();
            entityObj.rmZonesInfo = new RmZones();
            entityObj.rmRackId = dtoObj.rmRackId;
            entityObj.rmZonesInfo.rmZoneId = dtoObj.zoneId;
            entityObj.reservedForDummy = dtoObj.reservedForDummy;
            entityObj.rmRackName = dtoObj.rmRackName;
            entityObj.allocatedPlantId = dtoObj.plantId;
            entityObj.allocatedZoneId = dtoObj.zoneId;
            entityObj.plantId = dtoObj.plantId;entityObj.rmRackCode=dtoObj.rmRackCode;
            if (isUpdate) {
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }
  

    public convertEntityToDto(rackObject: RmRack): RmRackDTO {
        const racksDTO= new RmRackDTO;
        racksDTO.rmRackId = rackObject.rmRackId;
        racksDTO.zoneId = rackObject.rmZonesInfo.rmZoneId;
        racksDTO.zoneName = rackObject.rmZonesInfo.rmZoneName;
        racksDTO.rmRackName = rackObject.rmRackName;
        racksDTO.rmRackCode = rackObject.rmRackCode;
        racksDTO.reservedForDummy = rackObject.reservedForDummy;
        racksDTO.plantId = rackObject.plantId
        racksDTO.isActive = rackObject.isActive;
        racksDTO.createdAt = rackObject.createdAt;
        racksDTO.updatedAt = rackObject.updatedAt;
        racksDTO.createdUser = rackObject.createdUser;
        racksDTO.updatedUser = rackObject.updatedUser;
        racksDTO.versionFlag = rackObject.versionFlag;
        racksDTO.allocatedPlantId = rackObject.allocatedPlantId;
        racksDTO.allocatedZoneId = rackObject.allocatedZoneId;
        return racksDTO;
      }

      public convertEntityDetails(rackObject: RmRack): RmRackDetails {
        const racksDetails= new RmRackDetails(rackObject.rmRackId, rackObject.rmRackName, rackObject.rmRackCode,rackObject.reservedForDummy,rackObject.rmZonesInfo.rmZoneId,rackObject.rmZonesInfo.rmZoneName,rackObject.createdUser, rackObject.updatedUser,rackObject.isActive,rackObject.versionFlag,rackObject.allocatedZoneId,rackObject.allocatedPlantId);
        return racksDetails;
      }
}
